import { isAddress } from '../utils'

/**
 * Imágenes FAURT (fallback) para tokens sin arte propio del proyecto.
 * `dontpanic-alert.png` — señal "DON'T PANIC" del universo Hitchhiker.
 */
export const DEFAULT_TOKEN_ICON_URL = `${import.meta.env.BASE_URL}images/dontpanic-alert.png`
export const DEFAULT_TOKEN_BANNER_URL = `${import.meta.env.BASE_URL}images/dontpanic-alert.png`

/** Extensiones admitidas para logos empaquetados en `public/images/suggested-tokens/`. */
export const BUNDLED_TOKEN_LOGO_EXTENSIONS = ['svg', 'png', 'webp', 'jpg', 'jpeg'] as const

function bundledTokenLogoBasePath(address: string): string {
  const parsed = isAddress(address)
  const normalized = parsed || address
  return `${import.meta.env.BASE_URL}images/suggested-tokens/${normalized}`
}

/** Candidatos locales por dirección, probados en orden hasta que `<img>` cargue uno. */
export function getBundledTokenLogoUrlCandidates(address: string): string[] {
  const base = bundledTokenLogoBasePath(address)
  return BUNDLED_TOKEN_LOGO_EXTENSIONS.map((ext) => `${base}.${ext}`)
}

/** URL preferida empaquetada (primera extensión: SVG). */
export function getBundledTokenLogoUrl(address: string): string {
  return getBundledTokenLogoUrlCandidates(address)[0]!
}

/** Candidatos de icono: URL explícita → arte empaquetado (varias extensiones) → FAURT. */
export function getTokenIconSrcCandidates(address: string, explicitUrl?: string | null): string[] {
  const candidates = [
    explicitUrl?.trim() || null,
    ...getBundledTokenLogoUrlCandidates(address),
    DEFAULT_TOKEN_ICON_URL,
  ].filter((value): value is string => Boolean(value))

  return [...new Set(candidates)]
}

/** Candidatos de portada: URL explícita → FAURT. */
export function getTokenBannerSrcCandidates(explicitUrl?: string | null): string[] {
  const candidates = [explicitUrl?.trim() || null, DEFAULT_TOKEN_BANNER_URL].filter(
    (value): value is string => Boolean(value),
  )

  return [...new Set(candidates)]
}

/** Icono resuelto para perfiles (prioriza arte empaquetado). */
export function resolveTokenProfileIconUrl(address: string): string {
  return getBundledTokenLogoUrl(address)
}

/** Portada resuelta para perfiles sin imagen curada local. */
export function resolveTokenProfileBannerUrl(): string {
  return DEFAULT_TOKEN_BANNER_URL
}
